import {PluginApi} from "./PluginApi";
import {AccessToken, GetTokenOptions, TokenCredential} from '@azure/identity'
import { TokenCredentialAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/azureTokenCredentials";
import {Client} from "@microsoft/microsoft-graph-client";
import {User, Message} from '@microsoft/microsoft-graph-types'
import {MailFolder} from '@microsoft/microsoft-graph-types-beta'
import React from "react";

export class GraphApi {
    _client: Client;
    
    constructor(private _pluginApi: PluginApi) {
        const tokenCredential = new GraphExchangeTokenCredential(this._pluginApi);
        const authProvider = new TokenCredentialAuthenticationProvider(tokenCredential, {
            scopes: ["https://graph.microsoft.com/.default"]
        });
        this._client = Client.initWithMiddleware({authProvider: authProvider});
    }
    
    public async getUser() {
        return await this._client
            .api("me")
            .get() as User;
    }
    
    public async getFolder(messageId: string, properties: string[]|undefined = undefined) {
        const message = await this._client
            .api(`/me/messages/${messageId}`)
            .select(["parentFolderId"])
            .get() as Message;
        
        properties ??= ["displayName", "wellKnownName", "id"];
        
        return await this._client
            .api(`/me/mailFolders/${message.parentFolderId}`)
            .version("beta")
            .select(properties)
            .get() as MailFolder;
    }
}

class GraphExchangeTokenCredential implements TokenCredential {
    _current: AccessToken | undefined;
    
    constructor(private _pluginApi: PluginApi) {}
    
    public async getToken(scopes: string | string[], _options?: GetTokenOptions): Promise<AccessToken> {
        
        if (!this._current || Date.now() >= this._current.refreshAfterTimestamp)
        {
            if (typeof scopes === "string")
                scopes = [scopes];
            const response = await this._pluginApi.exchangeForGraphToken(scopes);
            const expiryTime = new Date(response.expiryTime);
            const refreshTime = new Date(response.refreshTime);

            this._current = {
                token: response.accessToken,
                tokenType: "Bearer",
                expiresOnTimestamp: expiryTime.getTime(),
                refreshAfterTimestamp: refreshTime.getTime()
            };    
        }
        
        return this._current; 
    }
}

export const GraphApiContext = React.createContext<GraphApi>(null);
